import React from 'react';
import { Route, Routes } from "react-router-dom";
import { USERROUTES } from "./url-constant";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UserLogin from "../pages/page/auth/userLogin";
import UserOtp from '../pages/page/auth/userOtp';
import UserProfileIntroduction from '../pages/page/UserProfileIntroduction';
import NewuserPage from '../pages/page/NewuserPage';
import CompleteTest from '../pages/page/completeTest';
import UserProtectedRoute from './userProtectedRoute';
import UserProfile from '../pages/page/auth/userProfile';
import UserAppLogOut from './userAppLogOut';
import PreviewAllAns from '../pages/page/auth/previewAllAns';
import NewCode from '../pages/page/latestChanges/newCode';


const UserRouteData = () => {
  return (
    <div>
      <Routes>

        <Route path={USERROUTES.USERLOGIN} element={<UserLogin />} />
        {/* <Route path={USERROUTES.lATESTPAGE} element={<NewCode />} /> */}
        <Route path={USERROUTES.USEROTP} element={<UserOtp />} />
        <Route path={USERROUTES.TESTCOMPLETE} element={<CompleteTest />} />
        <Route
          path={USERROUTES.USERPROFILEINTRODUCTION}
          element={<UserProtectedRoute component={<UserAppLogOut><UserProfileIntroduction /></UserAppLogOut>} />}
        />
        {/* <Route
          path={USERROUTES.NEWUSERPAGE}
          element={<UserProtectedRoute component={<UserAppLogOut><NewuserPage /></UserAppLogOut>} />}
        /> */}
        <Route
          path={USERROUTES.lATESTPAGE}
          element={<UserProtectedRoute component={<UserAppLogOut><NewCode /></UserAppLogOut>} />}
        />
        <Route
          path={USERROUTES.USERPROFILE}
          element={<UserProtectedRoute component={<UserAppLogOut><UserProfile /> </UserAppLogOut>} />}
        />
        <Route
          path={USERROUTES.PREVIEWALLANS}
          element={<UserProtectedRoute component={<UserAppLogOut><PreviewAllAns /> </UserAppLogOut>} />}
        />

      </Routes>
      <ToastContainer />
    </div>
  )
}

export default UserRouteData
